import { render, staticRenderFns } from "./SuperAdmin.vue?vue&type=template&id=750373f1&scoped=true"
import script from "./SuperAdmin.vue?vue&type=script&lang=js"
export * from "./SuperAdmin.vue?vue&type=script&lang=js"
import style0 from "./SuperAdmin.vue?vue&type=style&index=0&id=750373f1&prod&lang=scss&scoped=true"
import style1 from "./SuperAdmin.vue?vue&type=style&index=1&id=750373f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750373f1",
  null
  
)

export default component.exports